export default [// 库存量查询
    {
        path: "inventory/list",
        name: "inventory",
        component: () => import(/* webpackChunkName: "shipment" */ "@/views/boss/inventory/index"),
    },
    
]